import React, { Component } from 'react';
import Container from '@mui/material/Container';
import Viewer from '../forge/Viewer';
import EsriIOT from '../ArcGISIOT/EsriIOT';
import Projects from '../Data/sampleprojectdata.json';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';


// import DemoData from '../components/DemoData';

const projectDetails = Projects.find(project => project.name === localStorage.getItem('projectName'))

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


class ArcGISIOTView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      projectId: localStorage.getItem('projectName'),
      age: '',
      downloadReady: false,
      open: false,
      loading: false,
      packageReady: false,
      mapLoaded: false,
      readytoLoad: localStorage.getItem('ArgGIS'),
      modelUrn: ''
    }
  }

  handleChange = event => {
    this.setState({
      age: event.target.value,
      downloadReady: false,
      packageReady: true
    })
  }

  sleep = async (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  componentDidMount() {

  };

  runDownload = () => {

  };

  handleOpen = async () => {
    this.setState({ loading: true })
    await this.sleep(3000);
    this.setState({ open: true, loading: false })
  };

  handleClose = () => {
    this.setState({ open: false, downloadReady: true })
  };

  onMapLoad = () => {
    this.setState({ mapLoaded: true });
  };

  setupModelUrn = () => {
    const activeProjec = Projects.find(project => project.name === localStorage.getItem('projectName'))
    this.setState({ modelUrn: activeProjec.modelUrn })
  };


  render() {
    return (
      <>
        {(projectDetails) &&
          <>
            <Container maxWidth="lg" sx={{ mt: 2, mb: 2, lg: 2 }} maxWidth="xl">
              <Grid container spacing={3}>
                {/* <Grid item xs={12}>
                  <Paper
                    sx={{
                      p: 2, display: 'flex',
                      flexDirection: 'column',
                      height: 80,
                    }}>
                    <Typography variant="h5" component="div" gutterBottom color="green">
                      <b>ArcGIS API - Abraxas Twin Builder</b>
                    </Typography>
                  </Paper>
                </Grid> */}

                <Grid item xs={12} md={12} lg={12}>
                  <Paper
                    sx={{
                      p: 2,
                      display: 'flex',
                      flexDirection: 'column',
                      height: 650,
                    }}
                  >
                    <EsriIOT theme="light" onLoad={this.onMapLoad} />

                    <div id="paneDiv" className="esri-widget">
                      <p>Select a twin model and place it in the scene:</p>
                      <button id="tent" className="esri-button">Solarfarm Twin</button><br />
                      <button id="canoe" className="esri-button">Windfarm Twin</button>
                      <p id="credits">
                        models provided by
                        <a href="https://utilityContent.com/" target="_blank"
                        >UtilityContent.com</a>
                      </p> 
                      <hr />                 
                      <input type="checkbox" id="opacityInput" />
                      <label for="opacityInput">See through ground</label>
               
                    </div>
                  </Paper>
                </Grid>

              </Grid>
              <Modal
                open={this.state.open}
                onClose={this.handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <Box sx={modalStyle}>
                  <Typography id="modal-modal-title" variant="h6" component="h2">
                    Power BI Processing done
                  </Typography>
                  <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    A zip file containing the Power BI visual and an excel BOM is ready for download.
                  </Typography>
                  <Button variant="contained" onClick={() => this.handleClose()}>Done</Button>
                </Box>
              </Modal>

            </Container>

          </>
        }
        {
          !projectDetails &&
          <Container component="main" sx={{ mt: 12, mb: 12, lg: 12 }} maxWidth="lg">
            <Paper sx={{ p: 1, display: 'flex', flexDirection: 'column' }}>
              <h3>No Active Project Selected</h3>
            </Paper>
          </Container>
        }
      </>
    )
  }
}

export default ArcGISIOTView;